import { Avatar, Box, Stack, Text } from '@chakra-ui/react'

import CourseQ from '@/queries/CourseQ'
import TopicQ from '@/queries/TopicQ'
import type { Query } from '@/client/query'

interface TopicSummaryProps {
  topic: Query
  showDomainText?: boolean
}

export default function TopicSummary({
  topic,
  showDomainText = true,
}: TopicSummaryProps): React.ReactElement {
  const topicCourse = topic.one(TopicQ.getCourse())

  return (
    <Stack direction="row" spacing={4} align="center">
      <Avatar
        borderRadius="md"
        size="md"
        src={topic(TopicQ.icon) ?? ''}
        name={topic(TopicQ.name) ?? ''}
      />
      <Box>
        {showDomainText ? (
          <Text variant="eyebrow" mb={1}>
            {topicCourse(CourseQ.name)}
          </Text>
        ) : null}
        <Text fontWeight="bold">
          {topic(TopicQ.name)}
          {(topic(TopicQ.active) ?? true) ? '' : ' (Outdated topic)'}
        </Text>
      </Box>
    </Stack>
  )
}
